/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    ChildProviderDetail,
    ChildProviderDetailFromJSON,
    ChildProviderDetailFromJSONTyped,
    ChildProviderDetailToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    TicketingSettings,
    TicketingSettingsFromJSON,
    TicketingSettingsFromJSONTyped,
    TicketingSettingsToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityProviderSettingsFormData
 */
export interface IdentityProviderSettingsFormData {
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof IdentityProviderSettingsFormData
     */
    provider?: GuidIdAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof IdentityProviderSettingsFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof IdentityProviderSettingsFormData
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof IdentityProviderSettingsFormData
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {object}
     * @memberof IdentityProviderSettingsFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof IdentityProviderSettingsFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof IdentityProviderSettingsFormData
     */
    cardProvider?: GuidIdAndLabel;
    /**
     * 
     * @type {Array<TicketingSettings>}
     * @memberof IdentityProviderSettingsFormData
     */
    ticketingSettings?: Array<TicketingSettings> | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormData
     */
    useOneAirTicketing?: boolean;
    /**
     * 
     * @type {Array<ChildProviderDetail>}
     * @memberof IdentityProviderSettingsFormData
     */
    childProvidersDetails?: Array<ChildProviderDetail> | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    agencyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    countryDialingCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    stateProvince?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    officeID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    iataNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    postalCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormData
     */
    allowSalesTicketing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormData
     */
    instantTicketing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsFormData
     */
    isBSPPayment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    channelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    channelName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    flxUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    flxPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    pcc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    marketCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    marketName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    saleCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    accountCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    agentPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsFormData
     */
    agentRole?: string | null;
}

export function IdentityProviderSettingsFormDataFromJSON(json: any): IdentityProviderSettingsFormData {
    return IdentityProviderSettingsFormDataFromJSONTyped(json, false);
}

export function IdentityProviderSettingsFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'provider': !exists(json, 'provider') ? undefined : GuidIdAndLabelFromJSON(json['provider']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'cardProvider': !exists(json, 'cardProvider') ? undefined : GuidIdAndLabelFromJSON(json['cardProvider']),
        'ticketingSettings': !exists(json, 'ticketingSettings') ? undefined : (json['ticketingSettings'] === null ? null : (json['ticketingSettings'] as Array<any>).map(TicketingSettingsFromJSON)),
        'useOneAirTicketing': !exists(json, 'useOneAirTicketing') ? undefined : json['useOneAirTicketing'],
        'childProvidersDetails': !exists(json, 'childProvidersDetails') ? undefined : (json['childProvidersDetails'] === null ? null : (json['childProvidersDetails'] as Array<any>).map(ChildProviderDetailFromJSON)),
        'agencyName': !exists(json, 'agencyName') ? undefined : json['agencyName'],
        'countryDialingCode': !exists(json, 'countryDialingCode') ? undefined : json['countryDialingCode'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'stateProvince': !exists(json, 'stateProvince') ? undefined : json['stateProvince'],
        'officeID': !exists(json, 'officeID') ? undefined : json['officeID'],
        'iataNumber': !exists(json, 'iataNumber') ? undefined : json['iataNumber'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'allowSalesTicketing': !exists(json, 'allowSalesTicketing') ? undefined : json['allowSalesTicketing'],
        'instantTicketing': !exists(json, 'instantTicketing') ? undefined : json['instantTicketing'],
        'isBSPPayment': !exists(json, 'isBSPPayment') ? undefined : json['isBSPPayment'],
        'channelId': !exists(json, 'channelId') ? undefined : json['channelId'],
        'channelName': !exists(json, 'channelName') ? undefined : json['channelName'],
        'flxUserName': !exists(json, 'flxUserName') ? undefined : json['flxUserName'],
        'flxPassword': !exists(json, 'flxPassword') ? undefined : json['flxPassword'],
        'pcc': !exists(json, 'pcc') ? undefined : json['pcc'],
        'marketCode': !exists(json, 'marketCode') ? undefined : json['marketCode'],
        'marketName': !exists(json, 'marketName') ? undefined : json['marketName'],
        'saleCity': !exists(json, 'saleCity') ? undefined : json['saleCity'],
        'currencyCode': !exists(json, 'currencyCode') ? undefined : json['currencyCode'],
        'accountCode': !exists(json, 'accountCode') ? undefined : json['accountCode'],
        'agentName': !exists(json, 'agentName') ? undefined : json['agentName'],
        'agentPassword': !exists(json, 'agentPassword') ? undefined : json['agentPassword'],
        'agentRole': !exists(json, 'agentRole') ? undefined : json['agentRole'],
    };
}

export function IdentityProviderSettingsFormDataToJSON(value?: IdentityProviderSettingsFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'provider': GuidIdAndLabelToJSON(value.provider),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'disabled': value.disabled,
        'cardProvider': GuidIdAndLabelToJSON(value.cardProvider),
        'ticketingSettings': value.ticketingSettings === undefined ? undefined : (value.ticketingSettings === null ? null : (value.ticketingSettings as Array<any>).map(TicketingSettingsToJSON)),
        'useOneAirTicketing': value.useOneAirTicketing,
        'childProvidersDetails': value.childProvidersDetails === undefined ? undefined : (value.childProvidersDetails === null ? null : (value.childProvidersDetails as Array<any>).map(ChildProviderDetailToJSON)),
        'agencyName': value.agencyName,
        'countryDialingCode': value.countryDialingCode,
        'phoneNumber': value.phoneNumber,
        'email': value.email,
        'address': value.address,
        'stateProvince': value.stateProvince,
        'officeID': value.officeID,
        'iataNumber': value.iataNumber,
        'city': value.city,
        'country': value.country,
        'postalCode': value.postalCode,
        'allowSalesTicketing': value.allowSalesTicketing,
        'instantTicketing': value.instantTicketing,
        'isBSPPayment': value.isBSPPayment,
        'channelId': value.channelId,
        'channelName': value.channelName,
        'flxUserName': value.flxUserName,
        'flxPassword': value.flxPassword,
        'pcc': value.pcc,
        'marketCode': value.marketCode,
        'marketName': value.marketName,
        'saleCity': value.saleCity,
        'currencyCode': value.currencyCode,
        'accountCode': value.accountCode,
        'agentName': value.agentName,
        'agentPassword': value.agentPassword,
        'agentRole': value.agentRole,
    };
}


